import {createUseStyles} from 'react-jss';

export default createUseStyles({
  row: {
    display: 'flex',
    position: 'relative',

    '&:not(:last-child)': {
      paddingBottom: 3,
    },
  },
});
